import { useEffect } from 'react';
import { Box, Button, Card, CircularProgress, css, IconButton, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// import { UseLayerDashboardStore } from '../../features/layer-dashboard/stores/useLayerDashboardStore';
import { Scatterplot } from '../../features/layer-dashboard/components/Scatterplot';
import { useGetLayerDashboardInfo } from '../../features/layer-dashboard/api/layerDashboardApi';
import { Map } from '../../features/layer-dashboard/components/Map';
import { Histogramplot } from '../../features/layer-dashboard/components/Histogramplot';
import { Filter } from '../../features/layer-dashboard/components/Filter';
import { GeopostAppBar } from 'components/geopostAppBar/GeopostAppBar';
import { CardChart } from 'features/layer-dashboard/components/CardChart';
import { useLayerDashboardTabStore } from '../../features/layer-dashboard/context/LayerDashboardContext';
import { ILayerDashboard } from 'features/layer-dashboard/model/ILayerDashboardMainResponse';

const styles = css({
    background: '#c8c8c8',
    '& .container-master': {
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 8,
        paddingBottom: 8,
        boxSizing: 'border-box',
        height: 'calc(100% - 132px)'
    },
    '& .stack-row': {
        width: '100%',
        height: '50%',
        boxSizing: 'border-box',
    },
    '.container-loading': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0, 0.5)',
        zIndex: 9999999999999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&.hidden': {
            display: 'none'
        }
    }
});

export const LayerDashboardTab = ({data}: LayerDashboardTabProps) => {
    const { t } = useTranslation(['common']);

    const { displayableData, setDisplayableData, setResponse, title, clear, recalculate } = useLayerDashboardTabStore((state) => ({
        clear: state.clear,
        displayableData: state.displayableData,
        recalculate: state.recalculate,
        setDisplayableData: state.setDisplayableData,
        setResponse: state.setResponse,
        title: state.title,
    }));

    const [maximizedView, setMaximizedView] = useLayerDashboardTabStore((state) => [state.maximizedView, state.setMaximizedView]);

    useEffect(() => {
        if (data && displayableData.length === 0) {
            const parsedData = data.Data.map(x => JSON.parse(x));
            setDisplayableData(parsedData ?? []);
            setResponse(data);
        }
    }, [data?.Title]);

    return (
        <Stack direction='column' width='100vw' height='100vh' css={styles}>
            <GeopostAppBar title={'Dashboard - ' + title} buttons={[
                <Button key='recalculate' style={{ cursor: 'pointer', color: 'white' }} onClick={recalculate}>
                    <CheckCircleIcon />
                    Filter current selection
                </Button>,
                <Button key='clear' style={{ cursor: 'pointer', color: 'white' }} onClick={clear}>
                    <RotateLeftIcon />
                    Reset Filters
                </Button>,
            ]} />
            <Stack className='container-master' direction='column' flexGrow={1} spacing={1}>
                <Stack className='stack-row' direction='row' spacing={1} style={{display: maximizedView !== '' ? 'none' : 'flex'}}>
                    <Box width={'30%'} height={'100%'}>
                        <CardChart>
                            <Filter></Filter>
                        </CardChart>
                    </Box>
                    <Box width={'70%'} height={'100%'}>
                        <Map></Map>
                    </Box>
                </Stack>
                <Stack className='stack-row' direction='row' spacing={1} style={{height: maximizedView !== '' ? '100%' : '50%'}}>
                    <Box width={maximizedView === 'histogram' ? '100%' : (maximizedView === '') ? '50%' : '0%'} height='93%'>
                        <CardChart>
                            <Histogramplot></Histogramplot>
                        </CardChart>
                    </Box>
                    <Box width={maximizedView === 'scatterplot' ? '100%' : (maximizedView === '') ? '50%' : '0%'} height='93%'>
                        <CardChart>
                            <Scatterplot></Scatterplot>
                        </CardChart>
                    </Box>
                </Stack>
            </Stack>
        </Stack>
    );
};

interface LayerDashboardTabProps {
    data: ILayerDashboard | undefined,
}